
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_status",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Status')
        },
        value() {
            let status = ''
            if (this.unitLmsgStatus?.isMoving) {
                status = this.$t('Units.movements.Moving')
            } else
            // if (this.unitLmsgStatus?.ignition) {
            //     status = this.$t('Units.movements.Ignition on')
            // } else
            if (this.unitLmsgStatus?.isParked) {
                status = this.$t('Units.movements.Stopped')
            }

            return status
        },
        statusClass(){
            let timeAgo = this.unitLmsgTimeAgo
            if (!timeAgo && timeAgo !== 0) {
                return '';
            }
            //if(timeAgo<0) timeAgo *= -1

            if (timeAgo <= 5*60) {
                return 'update_status_online'
            } else
            if (timeAgo <= 15*60) {
                return 'update_status_online-recently'
            } else
            if (timeAgo <= 60*60) {
                return 'update_status_not-online-recently'
            } else
            {
                return 'update_status_not-online-long-time'
            }
        },
        statusIcon(){
            let timeAgo = this.unitLmsgTimeAgo
            return  timeAgo <= 60*60 ? 'status_online' : 'status_offline'
        },
        icon() {
            return this.showIcon ? 'car_' : false
        }
    },
}
</script>

<style scoped>

</style>